// extracted by mini-css-extract-plugin
module.exports = {"companiesBlockItem":"styles_companiesBlockItem__1US53","companyIcon":"styles_companyIcon__3xEm_","iconCon":"styles_iconCon__3lb0o"};